import { useState, FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/d6u4s6q9puk3bj9673q0";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      const body = new URLSearchParams({ email });
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setStatus(res.ok ? "success" : "error");
      if (res.ok) setEmail("");
    } catch {
      setStatus("error");
    }
  };

  return (
    <section className="py-36 bg-[#FAF7F0]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        <div className="max-w-2xl mx-auto text-center">
          <p
            className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-6"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Newsletter
          </p>
          <h2
            className="text-[#2C2825] text-4xl md:text-5xl lg:text-6xl leading-tight mb-5"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            Stay close to<br />
            <em>calm inspiration</em>
          </h2>
          <p
            className="text-[#8B8378] text-sm leading-relaxed mb-12 max-w-sm mx-auto"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Get gentle interior ideas, soft neutral spaces, and curated inspiration
            delivered occasionally.
          </p>

          {status === "success" ? (
            <div
              className="inline-block py-4 px-10 rounded-full bg-[#EDE6DA] text-[#6B5E53] text-sm"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Welcome to the journal — beautiful spaces await.
            </div>
          ) : (
            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                className="flex-1 px-6 py-4 rounded-full border border-[#C8BAA8] bg-transparent text-[#2C2825] text-sm placeholder-[#C8BAA8] focus:outline-none focus:border-[#8B8378] transition-colors"
                style={{ fontFamily: "'Inter', sans-serif" }}
              />
              <button
                type="submit"
                disabled={status === "loading"}
                className="bg-[#2C2825] text-[#FAF7F0] px-8 py-4 rounded-full text-xs tracking-[0.15em] hover:bg-[#3A3632] transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 uppercase"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {status === "loading" ? "Joining..." : "Join the Journal"}
              </button>
            </form>
          )}

          {status === "error" && (
            <p className="text-red-400 text-xs mt-3" style={{ fontFamily: "'Inter', sans-serif" }}>
              Something went wrong. Please try again.
            </p>
          )}

          <p
            className="text-[#C8BAA8] text-xs mt-5"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            No spam. Just quiet inspiration.
          </p>
        </div>
      </div>
    </section>
  );
}
